export default __webpack_public_path__ + "static/media/2022.22a44f86.pdf";